import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { hasFetchedCompanySubscriptionsSelector, isXgSeatRequiredForRolesSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";

/**
 * Whether only members holding a Sphere XG seat may take on the roles that need one, or "unknown"
 * while that cannot be told yet
 */

/**
 * Returns whether the plan of the workspace requires a Sphere XG seat for the roles that need one,
 * see isXgSeatRequiredForRolesSelector.
 *
 * A plan that limits the assigned seats is only told by the subscriptions, so it is not known for a
 * user that may read them while those of the selected workspace are not fetched yet or failed to
 * be. Users that may not read them never get them, so for them the company context is all there is
 * to tell.
 */
export function useXgSeatRequirement() {
  const {
    canViewSubscriptionDetails
  } = useHasUserValidRoleCompanyLevel();
  const isXgSeatRequired = useAppSelector(isXgSeatRequiredForRolesSelector);
  const hasFetchedSubscriptions = useAppSelector(hasFetchedCompanySubscriptionsSelector);
  if (isXgSeatRequired) {
    return "required";
  }
  return canViewSubscriptionDetails && !hasFetchedSubscriptions ? "unknown" : "notRequired";
}